"use client"
import { Flex, FlexColumn, TextHeading } from "@opensea/ui-kit"
import { slideClasses } from "@/components/collection/overview/styles"
import {
  ContentBlockCard,
  type ContentBlockCardProps,
} from "../ContentBlockCard/ContentBlockCard"

type TimelineSection = ContentBlockCardProps & { date?: string }

type TimelineContentBlockCarouselLayoutProps = {
  sections: TimelineSection[]
}

export function TimelineContentBlockCarouselLayout({
  sections,
}: TimelineContentBlockCarouselLayoutProps) {
  return sections?.map((section, index) => {
    return (
      <FlexColumn className={slideClasses()} key={section.title || index}>
        <Flex className="mb-4 items-center justify-center lg:mb-6">
          <TextHeading size="sm">{section.date || "Timeline"}</TextHeading>
          <div
            className="ml-4 h-[1px] flex-1 bg-[length:8px_1px]"
            style={{
              backgroundImage:
                index !== sections.length - 1
                  ? "linear-gradient(90deg, var(--color-border-3) 0%, var(--color-border-3) 50%, transparent 50%, transparent 100%)"
                  : undefined,
            }}
          />
        </Flex>
        <ContentBlockCard
          description={section.description}
          externalUrl={section.externalUrl}
          media={section.media}
          title={section.title}
        />
      </FlexColumn>
    )
  })
}
